export default {
  shared: {
    recentTransactionsTitle: "Movimientos recientes",
    recentTransactionsEmpty: "Aún no hay movimientos",
    recentTransactionsHint: "Su actividad reciente aparecerá aquí",
    loadingData: "Cargando datos del panel...",
    errorLoad: "Error al cargar los datos del panel",
    quickActions: "Acciones rápidas",
    title: "Panel",
    greetingWithName: "{{greeting}}, {{name}}",
    wallet: "Cartera",
  },
  admin: {
    greetingWithName: "{{greeting}}, Staff",
    overviewStats: "Resumen y estadísticas de la plataforma",
    notificationsTitle: "Notificaciones",
    notificationsViewAll: "Ver todas",
    notificationsLoading: "Cargando notificaciones...",
    notificationsError: "No se pudieron cargar las notificaciones",
    notificationsEmpty: "No hay notificaciones abiertas",
    notificationsMore:
      "{{count}} más — abra la bandeja para ver la lista completa",
    statTotalPlatformBalance: "Saldo total de la plataforma",
    statTotalSellers: "Vendedores totales",
    statActiveSellers: "{{count}} activos",
    statTotalActivities: "Actividades totales",
    statActiveActivities: "{{count}} activas",
    statActivitiesBreakdown: "{{restaurants}} restaurantes · {{services}} servicios",
    statTotalHouses: "Estructuras totales",
    statActiveHouses: "{{count}} activas",
  },
  partner: {
    overview: "Resumen de su negocio",
    sellerIdMissing: "No se encontró el ID de usuario del vendedor",
    greeting: "Aquí tiene un resumen de su negocio",
    myActivities: "Mis actividades",
    myActivitiesDesc: "Gestionar sus servicios y menús",
    bookings: "Reservas",
    bookingsDesc: "Ver reservas recientes",
    walletDesc: "Consultar sus ingresos",
    statsWalletBalance: "Saldo de la cartera",
    statsAmountOwed: "Importe adeudado",
    statsBookings30d: "Reservas (30 d.)",
    statsRevenue30d: "Ingresos (30 d.)",
    statsTransactions30d: "Operaciones (30 d.)",
    statsTrendVsPrev: "frente a 30 d. anteriores",
  },
  host: {
    myStructures: "Mis estructuras",
    myStructuresDesc: "Gestiona tus casas y dispositivos",
    walletDesc: "Consulta tus comisiones y pagos",
    overview: "Resumen de sus estructuras",
    hostIdMissing: "No se encontró el ID de usuario del anfitrión",
    greeting: "Aquí tiene un resumen de sus estructuras",
  },
  salesAgent: {
    overview: "Resumen del agente de ventas",
    userIdMissing: "No se encontró el ID de usuario del agente",
    loading: "Cargando el panel...",
    errorLoad: "Error al cargar el panel",
    greeting: "Sus comisiones y actividades/estructuras asignadas",
    walletBalance: "Saldo de la cartera",
    amountOwed: "Importe adeudado",
    lifetimeCredits: "Créditos totales (comisiones)",
    assignedScopes: "Ámbitos asignados",
    walletDesc: "Consulte sus comisiones y pagos",
    assignments: "Asignaciones",
    assignmentsDesc: "Vea actividades y estructuras en las que gana",
    support: "Soporte",
    supportDesc: "Obtenga ayuda o abra un ticket",
  },
  customer: {
    welcomeTitle: "¡Le damos la bienvenida de nuevo!",
    welcomeDesc: "Siga sus tickets de restaurante y puntos de fidelidad",
    myBookings: "Mis reservas",
    myBookingsDesc: "Ver y gestionar la subida de tickets",
    pointsBalance: "Saldo de puntos",
    pointsCount: "{{count}} puntos",
  },
} as const;
